import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PsHttpService } from '@patsnap/tahiti-core';
import type { PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import type { FeatureInitApi } from '../feature-init-api';
import type { FeatureInitResponse } from '../../types';
import { coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';
import type { QueryFeaturePermissionsApi, QueryFeaturePermissionsRequest, QueryFeaturePermissionsResponse } from '../query-feature-permissions-api';

@injectable()
export class FeatureInitApiImpl extends PsHttpService
    implements
    FeatureInitApi,
    QueryFeaturePermissionsApi
{

    get options() {
        return {
            baseURL: coreTelecomApiUrlPrefix,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }

    async getFeatureInit(): Promise<FeatureInitResponse> {
        const result = await this.get<PatSnapSuccessResponseData<FeatureInitResponse>>({
            url: '/v1/feature-init',
        });
        return result.data;
    }

    async queryFeaturePermissions(params: QueryFeaturePermissionsRequest): Promise<QueryFeaturePermissionsResponse> {
        const result = await this.get<PatSnapSuccessResponseData<QueryFeaturePermissionsResponse>>({
            url: '/user-capacity/feature-permissions',
            params,
        });
        return result.data;
    }
}
